import React from "react";
import { formatDateTime } from "../../helpers/helpers";
import { strikeOut, caceledFnc } from "./concerts.helper.jsx";
import "./concertsYear.css";

const ConcertsYear = ({ lang, year, concerts }) => {
  return (
    <div>
      <div className="concertYear">{year}</div>
      {concerts.map((concert, index) => (
        <div key={index} className="concertContainer">
          <div className="concertDateContainer">
            <div className="concertDate" style={strikeOut(concert.canceled)}>
              {formatDateTime(lang, concert.datum + "T" + concert.cas, true)}{" "}
            </div>
            {caceledFnc(concert.canceled, lang)}
          </div>
          <div className="concertText" style={strikeOut(concert.canceled)}>
            {concert["misto_" + lang.substring(0, 2)] === ""
              ? concert["misto_cs"]
              : concert["misto_" + lang.substring(0, 2)]}
          </div>
          <div className="concertInfo" style={strikeOut(concert.canceled)}>
            {concert["info_" + lang.substring(0, 2)] === ""
              ? concert["info_cs"]
              : concert["info_" + lang.substring(0, 2)]}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ConcertsYear;



// WEBPACK FOOTER //
// ./src/components/Concerts/ConcertsYear.jsx